var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVideoExitFullscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33317 5.66602C5.51727 5.66602 5.6665 5.51678 5.6665 5.33268V1.33268C5.6665 0.780397 6.11422 0.332682 6.6665 0.332682C7.21879 0.332682 7.6665 0.780397 7.6665 1.33268V5.33268C7.6665 6.62135 6.62183 7.66602 5.33317 7.66602H1.33317C0.780886 7.66602 0.33317 7.2183 0.33317 6.66602C0.33317 6.11373 0.780886 5.66602 1.33317 5.66602H5.33317Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 5.66602C18.4822 5.66602 18.333 5.51678 18.333 5.33268V1.33268C18.333 0.780397 17.8853 0.332682 17.333 0.332682C16.7807 0.332682 16.333 0.780397 16.333 1.33268V5.33268C16.333 6.62135 17.3777 7.66602 18.6663 7.66602H22.6663C23.2186 7.66602 23.6663 7.2183 23.6663 6.66602C23.6663 6.11373 23.2186 5.66602 22.6663 5.66602H18.6663Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.33317 18.332C5.51727 18.332 5.6665 18.4813 5.6665 18.6654V22.6654C5.6665 23.2176 6.11422 23.6654 6.6665 23.6654C7.21879 23.6654 7.6665 23.2176 7.6665 22.6654V18.6654C7.6665 17.3767 6.62183 16.332 5.33317 16.332H1.33317C0.780886 16.332 0.33317 16.7797 0.33317 17.332C0.33317 17.8843 0.780886 18.332 1.33317 18.332H5.33317Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6663 18.332C18.4822 18.332 18.333 18.4813 18.333 18.6654V22.6654C18.333 23.2176 17.8853 23.6654 17.333 23.6654C16.7807 23.6654 16.333 23.2176 16.333 22.6654V18.6654C16.333 17.3767 17.3777 16.332 18.6663 16.332H22.6663C23.2186 16.332 23.6663 16.7797 23.6663 17.332C23.6663 17.8843 23.2186 18.332 22.6663 18.332H18.6663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVideoExitFullscreen);
export default __webpack_public_path__ + "static/media/icon-video-exit-fullscreen.8f62dd26576f734b904d87bc61887ad8.svg";
export { ForwardRef as ReactComponent };